<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <transition name="fade">
                        <div v-if="error.status" class="notification is-danger">
                            {{ error.message }}
                        </div>
                        <div v-if="success.status" class="notification is-success">
                            {{ success.message }}
                        </div>
                    </transition>
                    <h3 class="title has-text-grey">Forgot Your Password?</h3>
                    <p class="subtitle has-text-grey">Input your registered email to reset your password</p>
                    <div class="box">
                        <form>

                            <div class="field">
                                <div class="control">
                                    <input v-model="data.email"
                                           v-bind:class="{ 'is-danger': error.status }"
                                           class="input"
                                           type="email"
                                           placeholder="Your Email"
                                           required=""
                                           autofocus="">
                                    <p v-if="error.errors.email" class="help is-danger">{{ error.errors.email[0] }}</p>
                                </div>
                            </div>
                            <button
                                    @click.prevent="submit"
                                    class="button is-block is-danger is-large is-fullwidth"
                                    v-bind:class="{'is-loading' : loading }">Reset password</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import apiAuth from '../../api/apiAuth'
    export default {
        data() {
            return {
                data: {
                    email: ''
                },
                error: {
                    status: false,
                    message: '',
                    errors: {
                        email: ''
                    }
                },
                success: {
                    status: false,
                    message: ''
                },
                loading: false
            }
        },
        methods: {
            submit() {
                this.loading = true
                apiAuth.passwordRecovery(this.data)
                    .then((response) => {
                        this.loading = false
                        this.error.status = false
                        this.error.errors.email = false
                        this.data.email = ''
                        this.success.status  = true
                        this.success.message = response.data.message
                    })
                    .catch((err) => {
                        this.loading = false
                        this.error.status = true
                        if ( err.response && err.response.status === 422 ) {
                            this.error.message = err.response.statusText
                            this.error.errors.email = err.response.data.email
                        } else {
                            this.error.message = 'Connection error!'
                        }
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auth/PasswordRecovery.vue